import { useSortable } from '@dnd-kit/sortable'
import React, { useEffect, useState } from 'react'
import { CSS } from '@dnd-kit/utilities';
// import { Td, Tr } from 'react-super-responsive-table';
import { Button } from 'reactstrap';
import { FaEdit, FaTrashAlt,FaGripVertical  } from 'react-icons/fa';
import DeleteConfirmationModal from 'pages/Ui/delete modal/DeleteConfirmationModal';
import { deleteComp } from 'services/apiComparable';
import useDeleteComp from './useDeleteComp';

const SortableRow  = ({comp,index,onEdit, isSelected}) => {
    
  // for making the remove disabled in the ui if the comp type is subject
  const[isTrue,setIsTrue] = useState(false)
  // for delete modal
  const[modalOpen, setModalOpen] = useState(false)
  // delete hook
  const{isDeleting, isDeleted, deleteComp} = useDeleteComp();

  useEffect(()=>{
    if(comp.comp_type === "subject"){
      setIsTrue(prev => !prev)
    }
  },[comp])

    const{attributes,listeners,setNodeRef,transform,transition,isDragging} = useSortable({
        id:comp.id,
        disabled: comp.comp_type === 'subject'
    })

    const style={
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: comp.comp_type === 'subject' ? '#f9f9f9' : 'white',
        // cursor: comp.comp_type === 'subject' ? 'not-allowed' : 'grab',
    };

    const toggleModal = () => setModalOpen(!modalOpen)

    const handleDelete = () =>{
      deleteComp({"comp_id":comp.comp_id})
      toggleModal();
    }
  return (<>
    <tr ref={setNodeRef} style={style} {...attributes} className={isSelected?'table-info':''}>
         <td>
         {/* DRAG HANDLE CELL */}
        <div 
          {...listeners} 
          style={{ 
            cursor: comp.comp_type === 'subject' ? 'not-allowed' : 'grab',
            touchAction: 'none', // Important for touch devices
            display: 'flex', // To center the icon
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <FaGripVertical />
        </div>
      </td>
          
    {/* DATA CELLS */}
      {/* <td>{index + 1}</td> */}
      <td>{comp.comp_type}</td>
      {/* <td>{comp.comp_type === 'subject' ? 'S' : 'C' + (comp.sequence - 1)}</td> */}
      {/* <td>{comp.curr_owner || '-'}</td> */}
      <td style={{position:'sticky',left:'10px',zIndex:3}}>{comp.property_address || '-'}</td>
      <td>{comp.proximity || '-'}</td>
      <td>{comp.location || '-'}</td>
      <td>{parseFloat(comp.sale_price).toLocaleString('en-us') || '-'}</td>
      {/* <td>{comp.sale_date || '-'}</td> */}
      <td>{comp.sale_date ?(()=>{
        const date = new Date(comp.sale_date);
        const mm = String(date.getMonth() + 1).padStart(2,'0');
        const dd = String(date.getDate()).padStart(2,'0');
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`
      })() : "-"}</td>
      <td>{comp.age_years || '-'}</td>
      <td>{comp.gross_living_area || '-'}</td>
      <td>{parseFloat(comp.price_per_gross_living_area).toLocaleString('en-us') || '-'}</td>
      <td>{comp.site_size || '-'}</td>
      <td>{comp.site_view || '-'}</td>
      <td>{comp.design_style || '-'}</td>
      <td>{comp.condition || '-'}</td>
      <td>{comp.total_rooms || '-'}</td>
      <td>{comp.bedrooms || '-'}</td>
      <td>{comp.baths || '-'}</td>
      <td>{comp.basement || '-'}</td>
      <td>{comp.heat_cool || '-'}</td>
      <td>{comp.garage_carport || '-'}</td>
      <td>{comp.porch_patio || '-'}</td>
      <td>{comp.mls_listing || '-'}</td>
        <tr>
          <td colSpan={2}>
            {comp.crs_file_link ? (
              <a href={comp.crs_file_link} target="_blank" rel="noreferrer">
                CRS
              </a>
            ) : (
              '-'
            )}
            {'\u00A0\u00A0\u00A0'} {/* Non-breaking spaces */}
            {comp.tax_records_link ? (
              <a href={comp.tax_records_link} target="_blank" rel="noreferrer">
                Tax
              </a>
            ) : (
              '-'
            )}
          </td>
        </tr>
      <td>{comp.overall_comparison || '-'}</td>
      
      <td>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
          <Button
            style={{ backgroundColor: '#00ADF0', color: 'white' }}
            size="sm"
            outline
            onClick={()=>onEdit(comp)}
          >
            <FaEdit />
          </Button>
          {!isTrue && <Button color="danger" outline size="sm" onClick={toggleModal}>
            <FaTrashAlt />
          </Button>}
        </div>
      </td>
    </tr>
    <DeleteConfirmationModal
      isOpen={modalOpen}
      toggle={toggleModal}
      onConfirm={handleDelete}
      message="Are you sure you want to delete this comparable?"
      isLoading={isDeleting}
    />
  </>
  )
}

export default SortableRow 